<i18n>
{
    "ru": {
        "my_title": "Мои подписчики",
        "title": "Подписчики",
        "guests": "Гости",
        "new_requests": "Новые заявки",
        "description_requests": "После одобрения заявки ваш профиль станет доступен пользователю для просмотра.",
        "has_no_subscribers": "У вас пока нет подписчиков",
        "user_has_no_subscribers": "У пользователя пока нет подписчиков",
        "has_no_guests": "В ваш профиль пока никто не заглядывал",
        "has_visiting": "Заходил(а)",
        "she_was_visiting": "Заходила",
        "he_was_visiting": "Заходил",
        "today_in": "сегодня в",
        "now": "только что",
        "yesterday_in": "вчера в",
        "in": "в",
        "confirm": "Подтвердить",
        "decline": "Отклонить",
        "error": "Ошибка отправки"
    }
}
</i18n>

<template>
    <div class="page-profile-subscribers">

        <Breadcrumb
            show-prev-button
            prev-path-name="users.detail"
            class="page-profile-subscribers__breadcrumbs"
            :classModificator="'profile-pages'"
            :items="breadcrumbs" />

        <ProfileWrapper>
            <template #content>
                <PageBlock
                    class="page-profile-subscribers__title"
                    small-header
                    small-description
                    big-title
                    :no-margin="true"
                    :profile="isDeviceDesktop"
                    :counter="usersList.length"
                    :title="computedTitle"/>

                <BaseTabs :data-visible="isLoaded"
                    v-if="isCurrentUser"
                    class="page-profile-subscribers__tabs page-profile-subscribers__tabs_opacity">

                    <BaseTab id="subscriptions"
                        class="page-profile-subscribers__tab"
                        :name="$t('breadcrumbs.profile.subscribers')">

                        <TransitionExpand
                            :data-hidden="usersRequestsList && usersRequestsList.length < 1"
                            class="page-profile-subscribers__items-list"
                            type="group">

                            <PageBlockSection v-if="usersRequestsList && usersRequestsList.length > 0"
                                :title="$t('new_requests')"
                                key="title"
                                class="page-profile-subscribers__tab-header"
                                big-title
                                no-padding-header>
                                {{ $t('description_requests') }}
                            </PageBlockSection>

                            <BaseUnit
                                class="page-profile-subscribers__person-block page-profile-subscribers__person-block_pending"
                                v-for="(item, index) in usersRequestsList"
                                :key="get(item, 'entity.id', index)"
                                size="small"
                                :with-counter="false"
                                :name="get(item, 'entity.fullName')"
                                :url="get(item, 'entity.htmlUrl')"
                                :picture="get(item, 'entity.photo.url', getUserNoImageLarge)"
                                :caption="get(item, 'entity.statusText')">
                                {{item}}

                                <div class="page-profile-subscribers__person-buttons" slot="side-right">

                                    <div
                                        @mouseover="overConfirm(index)"
                                        @mouseleave="leaveActions()"
                                        class="page-profile-subscribers__person-btn-wrap">

                                        <ButtonCircle
                                            class="page-profile-subscribers__person-button
                                    page-profile-subscribers__person-button_approve"
                                            bordered
                                            @click.native="approveUser(item)"
                                            icon="icon-check-current" />

                                        <transition name="fade">
                                            <div
                                                v-if="isDeviceDesktop"
                                                v-show="showConfirm === `show_${index}`"
                                                class="base-unit__tooltip">
                                                {{ $t('confirm') }}
                                            </div>
                                        </transition>
                                    </div>


                                    <div
                                        @mouseover="overDecline(index)"
                                        @mouseleave="leaveActions()"
                                        class="page-profile-subscribers__person-btn-wrap">

                                        <ButtonCircle
                                            @click.native="declineUser(item.id)"
                                            class="page-profile-subscribers__person-button
                                    page-profile-subscribers__person-button_cancel"
                                            bordered
                                            icon="icon-close-color" />

                                        <transition name="fade">
                                            <div
                                                v-if="isDeviceDesktop"
                                                v-show="showDecline === `show_${index}`"
                                                class="base-unit__tooltip">
                                                {{ $t('decline') }}
                                            </div>
                                        </transition>
                                    </div>
                                </div>

                            </BaseUnit>

                        </TransitionExpand>

                        <div v-if="usersRequestsList.length < 1 && usersList.length < 1"
                            :class="tabEmptyClass"
                            class="page-profile-subscribers__tab-empty">
                            <img class="tab-empty__picture"
                                v-lazy-load data-src="/img/empty_subscribers.jpg"
                                alt="" />
                            <div class="tab-empty__description">
                                <span> {{ $t('has_no_subscribers') }} </span>
                            </div>
                        </div>

                        <div class="page-profile-subscribers__items-list" :data-hidden="usersList.length < 1">
                            <TransitionExpand v-if="usersRequestsList && usersRequestsList.length > 0">
                                <PageBlockSection :title="$t('breadcrumbs.profile.subscribers')"
                                    class="page-profile-subscribers__tab-header"
                                    big-title
                                    hide-content
                                    no-padding-header />
                            </TransitionExpand>

                            <TransitionExpand type="group">
                                <BaseUnit
                                    class="page-profile-subscribers__person-block"
                                    v-for="(item, index) in usersList"
                                    :key="get(item, 'entity.id', index)"
                                    size="small"
                                    :with-counter="false"
                                    :name="get(item, 'entity.fullName')"
                                    :url="get(item, 'entity.htmlUrl')"
                                    :picture="get(item, 'entity.photo.url', getUserNoImageLarge)"
                                    :caption="get(item, 'entity.statusText')" />
                            </TransitionExpand>
                        </div>

                    </BaseTab>

                    <BaseTab id="guests"
                        :name="$t('breadcrumbs.profile.guests')">
                        <div class="page-profile-subscribers__items-list">

                            <div
                                v-if="get(guestsList, 'length', 0) < 1"
                                class="page-profile-subscribers__tab-empty
                                    page-profile-subscribers__tab-empty_guests">
                                <img class="tab-empty__picture"
                                    v-lazy-load data-src="/img/empty_subscribers.jpg"
                                    alt="" />
                                <div class="tab-empty__description">
                                    <span> {{ $t('has_no_guests') }} </span>
                                </div>
                            </div>

                            <BaseUnit
                                class="page-profile-subscribers__person-block page-profile-subscribers__person-block_guest"
                                v-for="(item, index) in guestsList"
                                :key="get(item, 'id', index)"
                                size="small"
                                :with-counter="false"
                                :name="get(item, 'user.fullName')"
                                :url="get(item, 'user.htmlUrl')"
                                :picture="get(item, 'user.photo.url', getUserNoImageLarge)"
                                :caption="formattedDate(item)" />
                        </div>
                    </BaseTab>

                </BaseTabs>

                <div v-else
                    :data-visible="isLoaded"
                    class="page-profile-subscribers__items-list
                        page-profile-subscribers__tabs_opacity
                        page-profile-subscribers__items-list_foreign">

                    <BaseUnit
                        class="page-profile-subscribers__person-block"
                        v-for="(item, index) in usersList"
                        :key="get(item, 'entity.id', index)"
                        size="small"
                        :with-counter="false"
                        :name="get(item, 'entity.name')"
                        :url="get(item, 'entity.htmlUrl')"
                        :picture="get(item, 'entity.photo.url', getUserNoImageLarge)"
                        :caption="get(item, 'entity.statusText')" />

                    <div v-if="usersList.length < 1"
                        :class="tabEmptyClass"
                        class="page-profile-subscribers__tab-empty">
                        <img class="tab-empty__picture"
                            v-lazy-load data-src="/img/empty_subscribers.jpg"
                            alt="" />
                        <div class="tab-empty__description">
                            <span> {{ $t('user_has_no_subscribers') }} </span>
                        </div>
                    </div>

                </div>
            </template>
        </ProfileWrapper>
    </div>
</template>

<script>
import get from 'lodash/get';
import filter from 'lodash/filter';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex'

import debounce from "lodash/debounce";
import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import PageBlock from '@/components/layout/AppPageBlock';
import BaseTabs from '@/components/ui/BaseTabs';
import ButtonCircle from '@/components/ui/buttons/ButtonCircle';
import PageBlockSection from '@/components/layout/AppPageBlockSection';
import ProfileWrapper from '@/components/profile/ProfileWrapper'
import Account from "~/models/users/accounts";
import User from "@/models/users/User";

const calendar = require('dayjs/plugin/calendar');

export default {
    name: 'Subscribers',
    layout: 'LayoutProfile',
    // middleware: ['profile'],
    components: {PageBlockSection, ButtonCircle, BaseTabs, PageBlock, Breadcrumb, ProfileWrapper},
    fetch() {
        this.$bus.$emit('fetch-complete')
    },
    async asyncData({ app, query, params, redirect }) {
        const profileIdentity = {
            personal: false,
            stranger: false,
            unlogin: false
        }
        let user = null;

        if(app.$auth.loggedIn && app.$auth.user.id === parseInt(params.userId)) {
            profileIdentity.personal = true;
            user = new User();
        }
        // иначе запрашивается публичный эндпоинт
        else {
            user = new User({ id: params.userId });

            profileIdentity.stranger = true;

            if(!app.$auth.loggedIn) {
                profileIdentity.unlogin = true;
            }
        }

        const profileRequest = await user.profile().get();
        const profileData = get(profileRequest, '[0]', {});

        const pageCrumbName = profileIdentity.personal ?
            app.i18n.t('breadcrumbs.profile.my_subscribers') :
            app.i18n.t('breadcrumbs.profile.subscribers');

        const baseUrl = app.i18n.__baseUrl
        const profileHref = app.router.resolve({
            name: 'users.detail'
        }).href

        const isStranger = parseInt(get(app.$auth, 'user.id')) !== parseInt(get(profileData, 'id'))

        if(isStranger && profileData.closedProfile) {
            redirect(301, profileHref);
        }

        const breadcrumbs = [
            {
                path: baseUrl,
                name: app.i18n.t('breadcrumbs.perfumes'),
            },
            {
                path: baseUrl + profileHref,
                name: profileData.fullName,
            },
            {
                path: baseUrl + profileHref + '/subscribers',
                name: pageCrumbName
            }
        ];

        return {
            breadcrumbs,
            profileIdentity,
            profileData
        }
    },
    data() {
        return {
            showConfirm: null,
            showDecline: null,
            breadcrumbs: [],
            usersList: [],
            usersRequestsList: [],
            guestsList: [],
            profileIdentity: {},
            profileData: null,
            isLoaded: false,
            usersListNextPageUrl: null,
            nextPageLoading: false
        }
    },
    globalBus: {
        'auth-complete'() {
            this.$fetch();

            this.profileIdentity.personal = this.$auth.loggedIn && this.$auth.user.id === parseInt(this.$route.params.userId)

            let user = new User({ id: this.$route.params.userId });

            if(this.profileIdentity.personal) {
                user = new User();
                this.loadData();
            }

            user.profile().get();
        },
        'user-logout-after'() {
            if(this.profileData.closedProfile) {
                this.$router.push({
                    name: 'users.detail',
                    params: {
                        userId: get(this.$route, 'params.userId')
                    }
                })
            }
        }
    },
    fetchOnServer: false,
    computed: {
        ...mapGetters(['isDeviceDesktop', 'getUserNoImageLarge']),
        isCurrentUser() {
            return !!(this.$auth.user &&
            parseInt(this.$route.params.userId) === parseInt(this.$auth.user.id));
        },
        computedTitle() {
            if(this.isCurrentUser) {
                return this.$t('breadcrumbs.profile.my_subscribers')
            }

            return this.$t('breadcrumbs.profile.subscribers')
        },
        tabEmptyClass() {
            return {
                'page-profile-subscribers__tab-empty_margin-top': this.profileIdentity.stranger
            }
        },
        computedMetaTitle(){
            return this.isCurrentUser ? 
                this.$options.filters.metaSitenameTitle(this.$t('my_title')) : 
                this.$options.filters.metaSitenameTitle(get(this.profileData, 'fullName') + ' - ' + this.$t('title'))
        }
    },
    mounted() {
        this.loadData();
    },
    created() {
        if(this.profileIdentity.stranger && this.profileData.closedProfile) {
            this.$router.push({
                name: 'users.detail',
                params: {
                    userId: get(this.$route, 'params.userId')
                }
            })
        }
    },
    methods: {
        get,
        loadData() {
            this.isLoaded = false;

            let userModel = new User({ id: this.$route.params.userId });

            if(this.profileIdentity.personal) {
                userModel = new User();
            }

            const requests = [
                userModel.followers().params({ 'per_page': 100 }).get(),
                this.profileIdentity.personal ? userModel.followersRequest().get() : {},
                this.profileIdentity.personal ? userModel.guests().get() : {},
            ]

            return Promise.all(requests).then((results) => {
                this.usersListNextPageUrl = get(results, '[0][0].nextPageUrl', null);

                this.usersList = get(results, '[0][0].items', [])
                this.usersRequestsList = get(results, '[1][0].items', [])
                this.guestsList = get(results, '[2][0].items', [])

                this.guestsList = this.guestsList.filter((item) => {
                    return item.user.id !== parseInt(this.$route.params.userId)
                })

                if(this.usersListNextPageUrl) {
                    this.fetchPage();
                }

                this.isLoaded = true;
            });
        },
        fetchPage: debounce(function() {
            if(this.nextPageLoading) return;

            this.nextPageLoading = true;

            this.$api.get(this.usersListNextPageUrl)
                .then((response) => {
                    if(get(response, 'data.items')) {
                        this.usersList = [
                            ...this.usersList,
                            ...get(response, 'data.items')
                        ]
                    }

                    this.usersListNextPageUrl = get(response, 'data.nextPageUrl', null);

                    // если есть еще страницы, рекурсивно выгребаем их
                    if(this.usersListNextPageUrl) {
                        this.fetchPage()
                    }
                }).finally(() => {
                    this.nextPageLoading = false;
                });
        }, 1000),
        async approveUser(userObj) {
            const userId = String(userObj.id)
            const accountModel = new Account()

            try {
                await accountModel.followersRequestAdd(userId).save().then(() => {
                    this.usersList.unshift(userObj);
                    this.usersRequestsList = filter(this.usersRequestsList, u => u.id !== userObj.id)
                })
            } catch(e) {
                this.$alert.info(this.$t('error'))
            }


        },
        async declineUser(userId) {
            const accountModel = new Account()

            try {
                await accountModel.followersRequestRemove(userId).delete().then(() => {
                    this.usersRequestsList = filter(this.usersRequestsList, u => u.id !== userId)
                })
            } catch(e) {
                this.$alert.info(this.$t('error'))
            }
        },
        formattedDate(item) {
            const date = get(item, 'createdAt');
            const gender = get(item, 'user.gender');
            let prefix = this.$t('he_was_visiting');
            if(gender === 'female') {
                prefix = this.$t('she_was_visiting')
            }

            dayjs.extend(calendar);
            return dayjs(date).calendar(null, {
                sameDay: `${prefix} [${this.$t('today_in')}] HH:mm`,
                lastDay: `${prefix} [${this.$t('yesterday_in')}] HH:mm`,
                lastWeek: `${prefix} DD.MM.YYYY ${this.$t('in')} HH:mm`,
                sameElse: `${prefix} DD.MM.YYYY ${this.$t('in')} HH:mm`
            })
        },
        overConfirm(num) {
            if(!this.isDeviceDesktop) return;

            this.showConfirm = `show_${num}`
        },
        overDecline(num) {
            if(!this.isDeviceDesktop) return;

            this.showDecline = `show_${num}`
        },
        leaveActions() {
            this.showConfirm = null
            this.showDecline = null
        }
    },
    head() {
        return {
            title: this.computedMetaTitle,
            htmlAttrs: {
                class: !this.isDeviceDesktop ? 'html view_mobile view_no-footer' : 'html view_desktop',
            }
        }
    },
};
</script>

<style lang="less">
.page-profile-subscribers {
    background: @color-white;

    margin-bottom: rem(12);
    padding-bottom: 27.5vh;

    @{mobile} & {
        min-height: calc(~"100vh - 100px");
    }

    @{desktop} & {
        .base-unit {
            &:hover {
                box-shadow: none;

                .base-unit__name {
                    color: @color-violet;
                }
            }
        }

        .page-block__content_padding-profile {
            padding: rem(2);
        }
    }

    &__title {
        .page-block__header {
            @{mobile} & {
                padding-bottom: rem(3);
            }
        }

        .page-block__counter {
            transform: translateY(rem(-0.7));

            @{desktop} & {
                transform: translateY(rem(-1));
            }
        }
    }

    &__person-block {
        padding: rem(12) 0 rem(11);

        &:first-child {
            padding-top: rem(6);
        }

        &_guest {
            --caption-width-small-screen: inherit;
            --caption-width: inherit;
        }

        @{mobile} & {
            .base-unit{
                &__content{
                    min-width: 0;
                }
                &__picture-wrapper{
                    min-width: rem(40);
                }
            }
        }
    }

    &__person-buttons {
        display: flex;
        align-items: center;

        padding: 0 rem(10);

        position: relative;
        left: rem(21);
        z-index: 99;

        @{mobile} & {
            padding-right: 0;
            padding-left: 0;
            left: rem(12);
        }
    }

    &__person-button {
        --size: rem(36);

        display: flex;
        align-items: center;

        border-radius: 50%;

        margin-right: rem(12);

        &_approve {
            --border-color: @color-green;

            color: @color-green;

            @{desktop} & {
                &:hover {
                    background-color: @color-green;
                    color: @color-white;
                }
            }
        }

        &_cancel {
            --border-color: @color-red;

            color: @color-red;

            @{desktop} & {
                &:hover {
                    background-color: @color-red;
                    color: @color-white;
                }
            }
        }
    }

    &__tab-header {
        --header-margin-bottom: rem(4);
        --content-margin-bottom: rem(12);
        --content-color: @color-gray;

        &:after {
            content: none;
        }
    }

    &__items-list {
        /*transition: opacity 2s ease;*/
        padding-bottom: rem(22);

        transition: all 1s ease;

        &_foreign {
            margin-top: rem(16);
            .page-padding();
        }

        &[data-hidden] {
            padding: 0;

            overflow: hidden;

            opacity: 0;
        }
    }

    .tabs__nav {
        margin-bottom: rem(18);
    }

    &__requests-header {
        .page-block {
            &__header, &__description-wrapper {
                padding-left: 0;
            }
        }
    }

    &__tab-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        margin-top: 0;

        @{desktop} & {
            margin-top: rem(32);
            max-width: rem(335);
            margin-left: auto;
            margin-right: auto;
        }

        &_margin-top {
            @{mobile} & {
                margin-top: rem(20);
            }
        }

        &_guests {

            @{desktop} & {
                margin-top: rem(58);

                .tab-empty__picture {
                    height: rem(230)
                }
            }
        }
    }

    .tab-empty {
        &__description {
            color: @color-gray-light;
            font-size: rem(15);
            text-align: center;
            max-width: rem(220);
            margin: 0 auto;
        }

        &__picture {
            display: block;
            margin-bottom: rem(20);
            width: 100%;
        }
    }

    &__tabs {

        &_opacity {
            opacity: 0;
            .animate(opacity);

            &[data-visible="true"] {
                opacity: 1;
            }
        }

        .tabs__panels {
            @{desktop} & {
                padding: 0;
            }
        }
    }

    &__person-btn-wrap {
        cursor: default;

        position: relative;

        .base-unit__tooltip {
            cursor: default;

            bottom: calc(100% + rem(8));

            pointer-events: none;
        }
    }
}
</style>
